import { makeStyles } from 'tss-react/mui';
export var taskManagementStyle = makeStyles()(function (theme) { return ({
    container: {
        padding: '24px',
    },
    tableWrapper: {
        marginTop: 16,
        backgroundColor: '#fff',
        borderRadius: 10,
    },
    pagination: {
        '& ul': {
            paddingTop: '24px',
            justifyContent: 'center',
            '& .Mui-selected': {
                color: theme.palette.common.white,
                background: theme.palette.primary.main,
                height: 24,
                minWidth: 24,
            },
        },
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px',
    },
    pageTitle: {
        fontSize: '32px',
        fontWeight: 700,
    },
    pageSubTitle: {
        fontSize: '14px',
        color: '#6b7280',
    },
    cardContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '16px',
        marginBottom: '24px',
    },
    card: {
        padding: '24px',
        borderRadius: '12px',
    },
    cardTitle: {
        fontSize: '14px',
        color: '#6b7280',
    },
    cardValue: {
        fontSize: '32px',
        fontWeight: 700,
        marginTop: '8px',
    },
    filterContainer: {
        display: 'flex',
        gap: '16px',
        marginBottom: '24px',
        flexWrap: 'wrap',
    },
    searchBox: {
        minWidth: '300px',
        flex: 1,
    },
}); });
